module.exports = __webpack_public_path__ + "static/media/environment.f041e750.png";